import { Spinner } from '@/components/Loader/Spinner';
import { Row, ThemeText } from '@/components/Theme';
import isEqual from 'lodash/isEqual';
import { memo } from 'react';

export const LoadingBar = memo(({id = null, contentContainerStyle = null, size = 'md', ...rest}) => {

    return (
        <Row gap={15} justifyContent={'center'} style={contentContainerStyle}>
            <Spinner size={size} style={{alignSelf: 'center'}} />
            {id != null && <ThemeText id={id} {...rest}/>}
        </Row>
    )

}, isEqual);